<template>
<CModal @mtdclosemodal="mtdClose" :show.sync="boo_modal" :close-on-backdrop="false" :centered="true" :title="title" :size="'xl'" :btn_cancel="true" :btn_ok="true" :booTitile="true" :scrollable="true">
    <div class="row px-3">
        <div class="col-md-12 col-lg-12 col-xs-12 text-center">
            <table class="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Cantidad</th>
                        <th>Producto</th>
                        <th>Precio</th>
                        <th>Subtotal</th>
                        <th>Estado</th>
                        <th>Eliminar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(det, index) in cpData" :key="index">
                        <template v-if="det.subsub_categorie_id != 13061">
                            <td>{{ index + 1 }}</td>
                            <td>
                                {{ det.quantity }}
                            </td>
                            <td>{{ det.product ? det.product.name : 'DETALLE DE ENVIO'}}</td>
                            <td v-if="posEditPrice !== index" @dblclick="mtdEditPrecies(index)">
                                {{ det.price }}
                            </td>
                            <td v-else>
                                <template>
                                    <input :disabled="det.state === 1" type="text" class="form-control form-control-sm text-center" v-model="newPrice"
                                    @keyup.enter="mtdOutFocusEditPrices" @blur="mtdOutFocusEditPrices" @keypress="validateNumberInput" />
                                </template>
                            </td>
                            <td>{{ parseFloat(det.quantity * det.price).toFixed(2) }}</td>
                            <td>
                                <div v-if="det.state == 2 || det.state == 3">
                                    <span class="badge rounded-pill text-bg-danger">Por Pagar</span>
                                </div>
                                <div v-else>
                                    <span class="badge rounded-pill text-bg-success">Pagado</span>
                                </div>
                            </td>
                            <td>
                                <div v-if="det.state == 2 || det.state == 3">
                                    <button @click="mtdDelCarrito(det)" class="btn btn-sm btn-danger">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <template #footer>
        <button @click="mtdClose" color="danger" class="btn btn-danger btn-sm">
            <i class="fa fa-times" />&nbsp;Cerrar
        </button>
    </template>
</CModal>
</template>

<script>
import CModal from "../../../../shared/modals/cModalFormCom.vue";
import {
    mapActions
} from 'vuex';

export default {
    name: "c-modalEditCarrito",
    components: {
        CModal
    },
    data() {
        return {
            ind: null,
            end: null,
            swal: null,
            total: 0,
            posEditQuantity: null,
            newQuantity: null,
            oldQuantity: null,
            tabla: [],
            posEditPrice: null,
            newPrice: null,
            oldPrice: null
        };
    },
    computed: {
        cpData() {
            let show = [];
            this.item.forEach((element) => {
                show.push(element);
            });
            this.tabla = show;
            return show;
        },
    },
    props: {
        title: String,
        boo_modal: Boolean,
        item: {
            type:Array,
            default:[]
        }
    },
    methods: {
      ...mapActions(["get", "post"]),

        validateNumberInput(event) {
            const regex = /^[0-9]*\.?[0-9]*$/;
            if (!regex.test(event.key)) {
                event.preventDefault();
            }
        },
        mtdClose() {
            this.posEditPrice = null;
            this.posEditQuantity = null;
            this.$emit("mtdCloseModalEdiatCarrito");
        },
        mtdDelCarrito: function (item) {
            this.$emit("mtdCommitDelCarrito", item.id);
        },
        mtdEditPrecies: function (pos) {
            this.posEditPrice = pos;
            this.oldPrice = this.cpData[pos].price;
            this.newPrice = this.cpData[pos].price;
        },

        mtdOutFocusEditPrices: function () {
            Swal.fire({
                icon: "warning",
                title: "¿Desea cambiar esta Precio?",
                width: "400px",
                /** buttons */
                showDenyButton: true,
                denyButtonText: `Rechazar`,
                denyButtonColor: "#bb8a17",
                confirmButtonText: "Permitir",
                confirmButtonColor: "#3085d6",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit("mtdCommitEditPrice", this.posEditPrice, this.newPrice);
                    this.posEditPrice = null;
                    this.oldPrice = null;
                    this.newPrice = null;
                } else if (result.isDenied) {
                    this.posEditPrice = null;
                    this.oldPrice = null;
                    this.newPrice = null;
                }
            });
        },
    },
};
</script>
